import React, { useEffect } from "react";
import { Label, Input } from "reactstrap";

export default function MiniGameFilter({ selectedMiniGame, onChange, options }) {
  useEffect(()=>{
    console.log("selectedMiniGame", selectedMiniGame, options)
  },[])
  return (
    <>
      <Label for="miniGameFilter">Filter by Mini Game</Label>
      <Input
        type="select"
        id="miniGameFilter"
        value={selectedMiniGame}
        onChange={onChange}
      >
        <option value="">Select...</option>
        {options.map((op) => (
          <option key={op.value} value={op.value}>
            {op?.gameName} - {op?.competency} - {op.label} 
          </option>
        ))}
      </Input>
    </>
  );
}